import React from 'react'

import { AuthProvider } from './AuthContext'
import { FilterProductProvider } from './FilterProductContext'
import { BlogFilterProvider } from './useBlogFilter'
import { CannectAssistantProvider } from './useCannectAssistant'
import { CannectCareProvider } from './useCannectCare'
import { CartCheckoutProvider } from './useCartCheckout'
import { IntrodutoryCourseProvider } from './useIntrodutoryCourse'
import { MarketPlaceProvider } from './useMarketPlace'
import { SignedUserProvider } from './useSignedUser'
import { TokenApiProvider } from './useTokenApi'
import { SchedulingProvider } from './useScheduling'
import { PrepareCartProvider } from './usePrepareCart'
import { MiniCheckoutProvider } from './useModalMiniCheckout'
import { DigitalJourneyProvider } from './useDigitalJourney'
import { TopMarqueeProvider } from '@cannect/contexts/TopMarqueeContext'

interface AppProviderProps {
  children: React.ReactNode
}

function AppProvider({ children }: AppProviderProps) {
  return (
    <AuthProvider>
      <TokenApiProvider>
        <TopMarqueeProvider>
          <MiniCheckoutProvider>
            <SignedUserProvider>
              <IntrodutoryCourseProvider>
                <FilterProductProvider>
                  <MarketPlaceProvider>
                    <CannectAssistantProvider>
                      <PrepareCartProvider>
                        <CartCheckoutProvider>
                          <CannectCareProvider>
                            <SchedulingProvider>
                              <BlogFilterProvider>
                                <DigitalJourneyProvider>{children} </DigitalJourneyProvider>
                              </BlogFilterProvider>
                            </SchedulingProvider>
                          </CannectCareProvider>
                        </CartCheckoutProvider>
                      </PrepareCartProvider>
                    </CannectAssistantProvider>
                  </MarketPlaceProvider>
                </FilterProductProvider>
              </IntrodutoryCourseProvider>
            </SignedUserProvider>
          </MiniCheckoutProvider>
        </TopMarqueeProvider>
      </TokenApiProvider>
    </AuthProvider>
  )
}

export default AppProvider
